<template>
  <div class="dataFormShell">
    <el-card class="card linkFormSection">
      <div slot="header" class="linkFormSection__header">
        <strong class="linkFormSection__title">数据集基本信息</strong>
      </div>

      <div
        class="appFormGrid"
        :class="isCreate ? 'appFormGrid--two' : 'appFormGrid--three'"
      >
        <el-form-item label="数据集名称" prop="name">
          <el-input
            v-model="ruleForm.name"
            placeholder="请输入数据集名称"
            :disabled="disabled"
          />
        </el-form-item>

        <el-form-item label="关联应用" prop="relationApp">
          <el-select
            v-model="ruleForm.relationApp"
            class="dataFormShell__control"
            placeholder="请选择关联应用"
            filterable
            clearable
            popper-class="linkListFilterDropdown"
            :disabled="disabled || !isCreate"
            @change="handleAppChange"
          >
            <el-option
              v-for="item in appOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          <p v-if="!isCreate" class="dataFormShell__fieldHint">
            编辑时不可更换关联应用，避免数据关联项与 App 字段不一致。
          </p>
        </el-form-item>

        <el-form-item v-if="!isCreate" label="key">
          <el-input
            :value="ruleForm.key"
            class="dataFormShell__control"
            disabled
          />
        </el-form-item>
      </div>
    </el-card>

    <data-filter-section
      :country="ruleForm.country"
      :api-version="ruleForm.apiVersion"
      :app-version="ruleForm.appVersion"
      :disabled="disabled"
    />

    <data-relation-section
      :list="relationList"
      :disabled="disabled"
      @update:list="$emit('update:relationList', $event)"
    />

    <el-card class="card linkFormSection">
      <div slot="header" class="linkFormSection__header">
        <strong class="linkFormSection__title">其他</strong>
      </div>
      <el-form-item label="备注（选填）">
        <el-input
          v-model="ruleForm.remarks"
          type="textarea"
          :rows="3"
          placeholder="运营备注"
          :disabled="disabled"
        />
      </el-form-item>
    </el-card>
  </div>
</template>

<script>
import DataFilterSection from './DataFilterSection.vue'
import DataRelationSection from './DataRelationSection.vue'

export default {
  name: 'DataFormShell',
  components: {
    DataFilterSection,
    DataRelationSection,
  },
  props: {
    ruleForm: { type: Object, required: true },
    relationList: { type: Array, required: true },
    appOptions: { type: Array, default: () => [] },
    isCreate: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    handleAppChange(value) {
      this.$emit('relation-app-change', value)
    },
  },
}
</script>

<style scoped>
.dataFormShell {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0;
}

.dataFormShell__control {
  width: 100%;
}

.dataFormShell__fieldHint {
  margin: 6px 0 0;
  font-size: var(--link-text-xs);
  color: var(--link-ink-muted);
  line-height: 1.4;
}
</style>
